import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect } from '../common';

class QueueLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange(selected) {
    this.props.updateSelectedOptions(selected);
    this.props.saveConfig();
  }

  render() {
    const { items, selectedItems } = this.state;

    return (
      <CustomMultiselect
        name={'Queue lists'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
      />
    );
  }
}

QueueLists.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('queueLists', vals)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    items: state.filters.allQueueLists,
    selectedItems: state.filters[chart].selectedQueueLists,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(QueueLists);
export { connected as QueueLists };
